import { forceNumeric } from "../utils/numeric-validation";
import { $Q } from "../utils/query-selector"

const validateForm = (e) => {
  e.preventDefault();
  const form = e.target.closest('form');
  const error = $Q('.error-check-js');

  const requiredInputs = [...form.elements]
    .filter((tag) => tag.required)
    .every((tag) => tag.value)

  if (!requiredInputs) {
    error.style.display = 'flex';
    return false;
  }

  error.style.display = 'none';

  return form.submit();
}

export const validateFormContact = () => {
  const btn = $Q('.send-contact');

  if (!btn) return;

  btn.addEventListener('click', validateForm);
}
